import { UserRoles } from '../../../models/User';
import { Injectable } from '@angular/core';
import { ActionsEnum, SendTasksTypeEnum } from '../data-sources/action-data-source.service';

@Injectable({
  providedIn: 'root'
})
export class ActionPermissionsService {
  constructor() { }

  private actionsMap: Map<ActionsEnum, UserRoles[]> = new Map([
    [ActionsEnum.SET_RESOLUTION, [UserRoles.MASTER, UserRoles.ADMIN]],
    [ActionsEnum.SET_DESTINATION, [UserRoles.MASTER, UserRoles.ADMIN]],
    [ActionsEnum.BULK_SET_DESTINATION, [UserRoles.MASTER, UserRoles.ADMIN]],
    [ActionsEnum.SET_RECEIVED_RESOLUTION, [UserRoles.MASTER, UserRoles.ADMIN]],
    [ActionsEnum.SEND_TASKS, [UserRoles.MASTER, UserRoles.ADMIN, UserRoles.MANAGER]],
    [ActionsEnum.DELETE_TASKS, [UserRoles.MASTER, UserRoles.ADMIN]],
    [ActionsEnum.BULK_SEND_TASKS, [UserRoles.MASTER, UserRoles.ADMIN, UserRoles.MANAGER]],
    [ActionsEnum.SEND_CRITICAL_TASKS, [UserRoles.MASTER, UserRoles.ADMIN, UserRoles.MANAGER]],
    [ActionsEnum.BULK_SEND_CRITICAL_TASKS, [UserRoles.MASTER, UserRoles.ADMIN, UserRoles.MANAGER]],
    [ActionsEnum.CHANGE_GROUND_POSITION_STATE, [UserRoles.MASTER, UserRoles.ADMIN]],
    [ActionsEnum.RESERVE_EXPEDITION, [UserRoles.MASTER, UserRoles.ADMIN]],
    [ActionsEnum.SEND_TO_EXPEDITION, [UserRoles.MASTER, UserRoles.ADMIN]],
    [ActionsEnum.SET_INVOICE_REQUESTED, [UserRoles.MASTER, UserRoles.ADMIN]],
    [ActionsEnum.ADD_GROUND_GROUP, [UserRoles.MASTER, UserRoles.ADMIN]],
    [ActionsEnum.ADD_PIGEONHOLE_GROUP, [UserRoles.MASTER, UserRoles.ADMIN]],
    [ActionsEnum.EDIT_GROUND_POSITION, [UserRoles.MASTER, UserRoles.ADMIN]],
    [ActionsEnum.CREATE_EXPEDITION, [UserRoles.MASTER, UserRoles.ADMIN]],
    [ActionsEnum.SET_TAGS_GROUND_GROUP, [UserRoles.MASTER]],
    [ActionsEnum.ENABLE_GROUND_GROUP_LEVEL, [UserRoles.MASTER]],
    [ActionsEnum.REMOVE_GROUND_GROUP, [UserRoles.MASTER]],
    [ActionsEnum.REMOVE_GROUND_GROUP, [UserRoles.MASTER, UserRoles.ADMIN]],
    [ActionsEnum.ADD_GROUND_GROUP_LEVEL, [UserRoles.MASTER, UserRoles.ADMIN]],
    [ActionsEnum.REMOVE_GROUND_GROUP_LEVEL, [UserRoles.MASTER, UserRoles.ADMIN]],
    [ActionsEnum.ADD_TENANT_LEVEL, [UserRoles.MASTER]],
    [ActionsEnum.REMOVE_TENANT_LEVEL, [UserRoles.MASTER]],
    [ActionsEnum.ENABLE_TENANT_LEVEL, [UserRoles.MASTER]],
    [ActionsEnum.SET_TENANT_STATE, [UserRoles.MASTER]],
    [ActionsEnum.SET_TENANT_ERP_CONFIG, [UserRoles.MASTER]],
    [ActionsEnum.SET_TENANT_ORIENTATION, [UserRoles.MASTER]],
    [ActionsEnum.SET_TENANT_ERP, [UserRoles.MASTER]],
    [ActionsEnum.SET_TENANT_MODULES, [UserRoles.MASTER]],
    [ActionsEnum.SET_TENANT_CONFIG, [UserRoles.MASTER]],
    [ActionsEnum.SET_TENANT_PROCESS, [UserRoles.MASTER]],
    [ActionsEnum.APPROVE_INVENTORY, [UserRoles.MASTER, UserRoles.ADMIN, UserRoles.MANAGER]],
    [ActionsEnum.REJECT_INVENTORY, [UserRoles.MASTER, UserRoles.ADMIN, UserRoles.MANAGER]],
    [ActionsEnum.APPROVE_PALLET_STOCK_POSITION, [UserRoles.MASTER, UserRoles.ADMIN]],
    [ActionsEnum.REMOVE_PRODUCT_FROM_PICKING_POSITION, [UserRoles.MASTER, UserRoles.ADMIN]],
    [ActionsEnum.SET_PRODUCT_TO_PICKING_POSITION, [UserRoles.MASTER, UserRoles.ADMIN]],
    [ActionsEnum.RUN_EXECUTION_PLAN, [UserRoles.MASTER, UserRoles.ADMIN]],
    [ActionsEnum.SET_EXECUTION_PLAN, [UserRoles.MASTER, UserRoles.ADMIN]],
    [ActionsEnum.UNSET_EXECUTION_PLAN, [UserRoles.MASTER, UserRoles.ADMIN]],
    [ActionsEnum.START_PACKING, [UserRoles.MASTER, UserRoles.ADMIN]],
    [ActionsEnum.CREATE_INTERNAL_OUT_ORDER, [UserRoles.MASTER, UserRoles.ADMIN]],
    [ActionsEnum.UPDATE_PRODUCT_PICTURE, [UserRoles.MASTER, UserRoles.ADMIN]],
    [ActionsEnum.DELETE_USER, [UserRoles.MASTER, UserRoles.ADMIN]],
    [ActionsEnum.EDIT_USER, [UserRoles.MASTER, UserRoles.ADMIN]],
    [ActionsEnum.CREATE_USER, [UserRoles.MASTER, UserRoles.ADMIN]],
    [ActionsEnum.EXIT_BY_GROUND_POSITION, [UserRoles.MASTER, UserRoles.ADMIN, UserRoles.MANAGER]],
    [ActionsEnum.UPDATE_GROUND_POSITION_ALIAS, [UserRoles.MASTER, UserRoles.ADMIN]],
    [ActionsEnum.CREATE_PRODUCT, [UserRoles.MASTER, UserRoles.ADMIN]],
    [ActionsEnum.EDIT_PRODUCT, [UserRoles.MASTER, UserRoles.ADMIN]],
    [ActionsEnum.REMOVE_PRODUCT, [UserRoles.MASTER, UserRoles.ADMIN]],
    [ActionsEnum.CHANGE_USER_PASSWORD, [UserRoles.MASTER]],
    [ActionsEnum.REMOVE_ALL_GROUP_LEVELS, [UserRoles.MASTER]],
    [ActionsEnum.SET_MODULE_PRODUCTS_CONFIG, [UserRoles.MASTER]],
    [ActionsEnum.SET_TENANT_INDEPENDENT_LEVELS, [UserRoles.MASTER]],
    [ActionsEnum.EDIT_POSITION_GROUP, [UserRoles.MASTER]],
    [ActionsEnum.EDIT_POSITION_TYPE, [UserRoles.MASTER]],
    [ActionsEnum.SET_TENANT_FEATURES, [UserRoles.MASTER]],
    [ActionsEnum.SET_PALLET_UNDER_ALERT, [UserRoles.ADMIN, UserRoles.MANAGER, UserRoles.MASTER]],
    [ActionsEnum.UNSET_PALLET_UNDER_ALERT, [UserRoles.ADMIN, UserRoles.MANAGER, UserRoles.MASTER]],
    [ActionsEnum.ADD_COMMENT_TO_PALLET, [UserRoles.ADMIN, UserRoles.MANAGER, UserRoles.MASTER]],
    [ActionsEnum.REMOVE_OUT_ORDER, [UserRoles.MASTER, UserRoles.ADMIN]],
    [ActionsEnum.RESET_OUT_ORDER, [UserRoles.MASTER, UserRoles.ADMIN]],
    [ActionsEnum.REMOVE_POSITION, [UserRoles.MASTER, UserRoles.ADMIN]],
    [ActionsEnum.SET_TENANT_PIGEONHOLE, [UserRoles.MASTER]],
    [ActionsEnum.EDIT_POSITIONS_TO_PIGEONHOLE, [UserRoles.MASTER]],
    [ActionsEnum.REMOVE_PIGEONHOLE, [UserRoles.MASTER, UserRoles.ADMIN]],
    [ActionsEnum.EDIT_PIGEONHOLE_STATE, [UserRoles.MASTER, UserRoles.ADMIN]],
    [ActionsEnum.EDIT_PIGEONHOLE_ALIAS, [UserRoles.MASTER, UserRoles.ADMIN]],
    [ActionsEnum.START_OUT_ORDER_VALIDATION, [UserRoles.MASTER, UserRoles.ADMIN]],
    [ActionsEnum.APPROVE_INVENTORY_REPORT, [UserRoles.MASTER, UserRoles.ADMIN, UserRoles.MANAGER]],
    [ActionsEnum.REJECT_INVENTORY_REPORT, [UserRoles.MASTER, UserRoles.ADMIN, UserRoles.MANAGER]],
    [ActionsEnum.ADD_COMMENT_TO_OUT_ORDER, [UserRoles.MASTER, UserRoles.ADMIN, UserRoles.MANAGER]],
    [ActionsEnum.REMOVE_COMMENT_FROM_OUT_ORDER, [UserRoles.MASTER, UserRoles.ADMIN, UserRoles.MANAGER]],
    [ActionsEnum.SET_PIGEONHOLE_GROUP, [UserRoles.MASTER, UserRoles.ADMIN]],
    [ActionsEnum.REMOVE_PIGEONHOLE_GROUP, [UserRoles.MASTER, UserRoles.ADMIN]],
    [ActionsEnum.CREATE_INTERNAL_IN_ORDER, [UserRoles.MASTER, UserRoles.ADMIN]]
  ]);

  private sendTasksTypeMap: Map<SendTasksTypeEnum, UserRoles[]> = new Map([
    [SendTasksTypeEnum.RECEIVING, [UserRoles.MASTER, UserRoles.ADMIN]],
    [SendTasksTypeEnum.DISPATCHING, [UserRoles.MASTER, UserRoles.ADMIN]],
    [SendTasksTypeEnum.RELOCATE_STORAGE, [UserRoles.MASTER, UserRoles.ADMIN]],
    [SendTasksTypeEnum.RELOCATE_DIVERGENT, [UserRoles.MASTER, UserRoles.ADMIN]],
    [SendTasksTypeEnum.RELOCATE_QUALITY, [UserRoles.MASTER, UserRoles.ADMIN]],
    [SendTasksTypeEnum.RELOCATE_DOCK, [UserRoles.MASTER, UserRoles.ADMIN]],
    [SendTasksTypeEnum.LOAD_DISPATCH, [UserRoles.MASTER, UserRoles.ADMIN]],
    [SendTasksTypeEnum.RELOCATE_POSITION, [UserRoles.MASTER, UserRoles.ADMIN]],
    [SendTasksTypeEnum.RELOCATE_EXPEDITION, [UserRoles.MASTER, UserRoles.ADMIN]],
    [SendTasksTypeEnum.RELOCATE_FREE, [UserRoles.MASTER, UserRoles.ADMIN]],
    [SendTasksTypeEnum.PICKING, [UserRoles.MASTER, UserRoles.ADMIN]],
    [SendTasksTypeEnum.RELOCATE_FROM_PICKING, [UserRoles.MASTER, UserRoles.ADMIN]],
    [SendTasksTypeEnum.INVENTORY_BY_GROUND_POSITION_GROUP, [UserRoles.MASTER, UserRoles.ADMIN, UserRoles.MANAGER]],
    [SendTasksTypeEnum.INVENTORY_BY_PRODUCT, [UserRoles.MASTER, UserRoles.ADMIN, UserRoles.MANAGER]],
    [SendTasksTypeEnum.INVENTORY_BY_TAG_RFID, [UserRoles.MASTER, UserRoles.ADMIN, UserRoles.MANAGER]],
    [SendTasksTypeEnum.PRODUCT_INVENTORY_BY_CRATE_TAG_RFID, [UserRoles.MASTER, UserRoles.ADMIN, UserRoles.MANAGER]],
    [SendTasksTypeEnum.INVENTORY_BY_GROUND_POSITION, [UserRoles.MASTER, UserRoles.ADMIN, UserRoles.MANAGER]],
    [SendTasksTypeEnum.INVENTORY_BY_MISSING_CRATE, [UserRoles.MASTER, UserRoles.ADMIN, UserRoles.MANAGER]],
    [SendTasksTypeEnum.INVENTORY_BY_PIGEONHOLE_POSITION, [UserRoles.MASTER, UserRoles.ADMIN, UserRoles.MANAGER]],
  ]);

  hasPermission(action: ActionsEnum | SendTasksTypeEnum, userRole: UserRoles): boolean {
    if (isActionEnum(action)) {
      const actionRoles = this.actionsMap.get(action) || [];
      return actionRoles.includes(userRole);
    }

    if (isSendTasksTypeEnum(action)) {
      const taskRoles = this.sendTasksTypeMap.get(action) || [];
      return taskRoles.includes(userRole);
    }

    return false;
  }
}

function isActionEnum(value): value is ActionsEnum {
  return Object.values(ActionsEnum).includes(value);
}

function isSendTasksTypeEnum(value): value is SendTasksTypeEnum {
  return Object.values(SendTasksTypeEnum).includes(value);
}
